import { useAppSelector } from "@/app/hooks";
import {
  offeringCatalog,
  stageColumns,
  StagePosition,
} from "../config/offeringCatalog";

interface UseStageFeatureMatrixResult {
  catalog: typeof offeringCatalog;
  columns: typeof stageColumns;
  /** The logged-in company's stage position, or null when it has no stage. */
  currentStagePosition: StagePosition | null;
}

/**
 * Supplies the static offering catalog together with the member company's
 * current stage position (from `userAppSettings.companyStage`). Null-safe:
 * companies without a stage yield `currentStagePosition: null`.
 */
export function useStageFeatureMatrix(): UseStageFeatureMatrixResult {
  const companyStage = useAppSelector(
    (state) => state.userAppSettings.userAppSettings?.companyStage ?? null,
  );

  const position = companyStage?.position ?? null;
  const currentStagePosition =
    position !== null && position >= 1 && position <= 4
      ? (position as StagePosition)
      : null;

  return {
    catalog: offeringCatalog,
    columns: stageColumns,
    currentStagePosition,
  };
}
